import CustomModal from "Components/CommonComponents/CustomModal";
import AssetView from "Pages/AssetView/AssetView";
import { IAssetDetails } from "Pages/ScheduleView/ScheduleAssetList";
import { useState } from "react";
import "../../index.css";
// import styled from "styled-components";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import { Table } from "antd";
import ViewIcon from "Assets/Icons/ViewIcon";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
export const removeFacultyPrefix = (value: any) => {
  let val = value;

  if (val.startsWith("Faculty_")) {
    val = val.substring("Faculty_".length);
  }

  if (val === "ppt") {
    val = val.toUpperCase();
  }
  return val;
};
export interface ChapterContentTableInterface {
  data: any;
  loading: boolean;
  courseId: any;
  pagination: any;
  setPagination: any;
  onPageChange: any;
  setItemsPerPage: any;
  module?: any;
}
const ChapterContentTable = ({
  data,
  loading,
  courseId,
  pagination,
  setPagination,
  onPageChange,
  setItemsPerPage,
  module,
}: ChapterContentTableInterface) => {
  const { screen }: any = useWindowSize();
  const isMobile = ["xs", "sm", "md"].includes(screen);
  const [selectedAsset, setSelectedAsset] = useState<IAssetDetails>({});
  const [assetViewOpen, setAssetViewOpen] = useState<boolean>(false);
  const handleTitleCLick = (assetContent: any) => {
    setSelectedAsset(assetContent);
    setAssetViewOpen(true);
    const contentViewEvent = {
      event: "ag_planner_library_view_library_content",
      CONTENT_ID: assetContent?.assetId ?? "",
      CONTENT_TYPE: assetContent?.assetType ?? "",
      CONTENT_TAGS: assetContent?.tags ?? "",
      IS_FACULTY_CONTENT: module === "facultyContent",
      IS_STUDENT_CONTENT: module === "studentContent",
    };
    console.log(
      "[GTM Track Event] ag_planner_library_view_library_content:",
      contentViewEvent
    );
    pushToDataLayerForGTM(contentViewEvent);
  };
  const returntagsname = (tags: any) => {
    const tagArr = tags && tags.split(",");
    return (
      <div className="tagsInTableStyle">
        {tagArr &&
          tagArr.length > 0 &&
          tagArr.map((ele: string, index: number) => {
            return (
              <span key={index} className="tagsSpan">
                {ele}
              </span>
            );
          })}
      </div>
    );
  };
  const columns: any = [
    {
      title: "Content Title",
      dataIndex: "title",
      fixed: "left",
      width: isMobile ? 110 : undefined,
      render: (_: any, record: any) => {
        return (
          <span
            className="tableIdStyle"
            onClick={() => handleTitleCLick(record)}
          >
            {record?.title}
          </span>
        );
      },
    },
    {
      title: "Content Type",
      dataIndex: "assetType",
      width: 140,
      render: (_: any, record: any) => {
        return <span>{record?.assetType}</span>;
      },
    },
    {
      title: "Content Tags",
      dataIndex: "tags",
      width: isMobile ? 190 : undefined,
      render: (_: any, record: any) => {
        return returntagsname(record?.tags);
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      width: 60,
      render: (_: any, record: any) => {
        return (
          <span className="tableIdStyle">
            <ViewIcon onClick={() => handleTitleCLick(record)}></ViewIcon>
          </span>
        );
      },
    },
  ];
  const handleTableChange = (paginations: any, filters: any, sorter: any) => {
    const sortField = sorter.field || pagination.sortField;
    let sortOrder = pagination.sortOrder;
    if (sorter.order !== undefined) {
      sortOrder = sorter.order === "descend" ? "DESC" : "ASC";
    }
    const currentPage =
      pagination.pageSize != paginations.pageSize ? 1 : paginations.current;
    onPageChange(paginations.current);
    setItemsPerPage(paginations.pageSize);
    setPagination({
      ...paginations,
      current: currentPage,
      sortField,
      sortOrder: sortOrder,
    });
  };
  return (
    <>
      <TableLayoutAntd isLoader={loading}>
        <Table
          bordered
          size="small"
          columns={columns}
          dataSource={data}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={
            isMobile
              ? {
                  x: 445,
                  y: 110 * 4,
                }
              : {
                  y: 110 * 4,
                }
          }
          style={{ position: "relative", zIndex: "0" }}
        />
      </TableLayoutAntd>
      <CustomModal
        modal={assetViewOpen}
        centered={true}
        backdrop={true}
        size={"xl"}
        fullscreen={true}
        className={
          ["Faculty_Ebook", "Ebook", "Faculty_ppt", "PPT"].includes(
            selectedAsset.assetType || ""
          )
            ? "document-viewer-fullscreen-modal"
            : undefined
        }
        title={selectedAsset.title}
        toggle={() => {
          setAssetViewOpen(false);
          setSelectedAsset({});
        }}
      >
        <div
          className="modern-asset-viewer-container w-100 d-flex align-items-center justify-content-center"
          style={{
            height: "95vh",
            maxHeight: "95vh",
            overflow: "hidden",
            background: "linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)",
            padding: "20px",
          }}
        >
          <AssetView
            courseId={courseId}
            assetId={selectedAsset.assetId}
            type={selectedAsset.assetType}
            title={selectedAsset.title}
            desc={selectedAsset.desc}
          />
        </div>
      </CustomModal>
    </>
  );
};
export default ChapterContentTable;
